import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { OutfitsPanelProps } from "./OutfitsPanel";
const OutfitsPanel = lazy(() => import("./OutfitsPanel").then((module) => ({ default: module.OutfitsPanel })));

/** Clothing of the cast on the storyboard step; a production without characters clears the slot. */
export function mountOutfitsPanel(projectId: string, props: OutfitsPanelProps | null) {
  if (!props) return clearStudioView("outfits-panel");
  setStudioView("outfits-panel", `outfits-panel:${projectId}`, <OutfitsPanel {...props} />);
}
